export default "__VITE_PUBLIC_ASSET__c406865c__"